import React, { useCallback } from 'react';
import { FormikProps } from 'formik';
import { ContactUpdatedFields, UpdateDepositValues } from 'types';
import { ContactInformationFormView } from './ContactInformationFormView';
import './ContactInformationForm.scss';

export const UpdateContactForm: React.FC<
  FormikProps<UpdateDepositValues> & { updatedFields: ContactUpdatedFields }
> = ({ values, setFieldValue, handleChange, ...props }) => {
  const handleTowns = useCallback(
    (latitude: number, longitude: number, towns: string[]) => {
      if (!towns.includes(values.city)) {
        setFieldValue('geoLoc', { latitude, longitude });
        setFieldValue('city', towns[0]);
      }
    },
    [values.city, setFieldValue],
  );

  return (
    <div className="update-contact-form">
      <ContactInformationFormView
        onReturn={() => {}}
        onSubmit={() => {}}
        {...props}
        handleTowns={handleTowns}
        onChange={handleChange}
        values={values}
        setFieldValue={setFieldValue}
        showActions={false}
      />
    </div>
  );
};
